import { fetchToken } from "../../../common/FetchCookie";
import { BASE_URL, CANDIDATE, CANDIDATE_BASIC_DETAILS, CITIES, COUNTRIES, PUBLIC, STATES } from "../../../common/URLs";

export const fetchCountry = async () => {
  try {
    const response = await fetch(
      `${BASE_URL}/${PUBLIC}/${COUNTRIES}`,
      {
        method: "GET",
        headers: { Accept: "application/json" },
      }
    );

    const data = await response.json()
    // console.log("list of countries", data);
    return data;
  } catch (error) {
    console.log("Error in making the REQUEST", error);
  }
};
export const fetchState = async (uuid) => {
  try {
    const response = await fetch(
      `${BASE_URL}/${PUBLIC}/${STATES}/${uuid}`,
      {
        method: "GET",
        headers: { Accept: "application/json" },
      }
    );

    const data = await response.json();
    console.log("list of states", data);
    return data;
  } catch (error) {
    console.log("Error in making the REQUEST", error);
  }
};
export const fetchCities = async (uuid) => {
  try {
    const response = await fetch(
      `${BASE_URL}/${PUBLIC}/${CITIES}/${uuid}`,
      {
        method: "GET",
        headers: { Accept: "application/json" },
      }
    );

    const data = await response.json();
    // console.log("list of states", data);
    return data;
  } catch (error) {
    console.log("Error in making the REQUEST", error);
  }
};

// details post api
export const aboutSaveProfile = async ({ data }) => {
  try {
    const token = await fetchToken()

    const response = await fetch(
      `${BASE_URL}/${CANDIDATE}/${CANDIDATE_BASIC_DETAILS}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );
    const responseData = await response.json();
    if (responseData) {
      console.log(responseData.response.msg);
      return responseData;
    }
  } catch (error) {
    console.log("error in making the request", error);
    throw error;
  }
};

